/*
  Accessibility enhancement for the existing mobile off-canvas menu
  (".panel-menu", driven by the bundled "initMM" plugin in vendor.min.js).
  This script does NOT reimplement or alter the open/close/slide-level
  logic — it only observes the same "mm-open"/"mmitemopen" classes that
  plugin already toggles, and layers on:
    - aria-hidden / aria-expanded / aria-controls, kept in sync via
      MutationObserver so it works no matter how the state changes
    - Escape-to-close, by re-using the existing overlay's own click
      handler (".mm-fullscreen-bg" already closes the menu on click)
    - a basic focus trap while a panel is open
*/
(function () {
  "use strict";

  var panels = document.querySelectorAll(".panel-menu");
  if (!panels.length) return;

  var overlay = document.querySelector(".mm-fullscreen-bg");
  var toggles = document.querySelectorAll(".mainmenumob-js, .catmenumob-js");

  function isOpen() {
    return document.body.classList.contains("mm-open");
  }

  function syncAria() {
    var openPanel = document.querySelector(".panel-menu.mmitemopen");
    var open = !!openPanel;

    panels.forEach(function (panel) {
      panel.setAttribute("aria-hidden", panel.classList.contains("mmitemopen") ? "false" : "true");
    });

    toggles.forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (openPanel) {
        if (!openPanel.id) {
          openPanel.id = "tt-mobile-menu-panel-" + Array.prototype.indexOf.call(panels, openPanel);
        }
        toggle.setAttribute("aria-controls", openPanel.id);
      }
    });
  }

  panels.forEach(function (panel) {
    if (!panel.hasAttribute("aria-hidden")) panel.setAttribute("aria-hidden", "true");
  });
  toggles.forEach(function (toggle) {
    if (!toggle.hasAttribute("aria-expanded")) toggle.setAttribute("aria-expanded", "false");
    if (!toggle.hasAttribute("role") && toggle.tagName !== "A" && toggle.tagName !== "BUTTON") {
      toggle.setAttribute("role", "button");
    }
  });

  if ("MutationObserver" in window) {
    new MutationObserver(syncAria).observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    panels.forEach(function (panel) {
      new MutationObserver(syncAria).observe(panel, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen() && overlay) {
      overlay.click();
    }
  });

  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Tab" || !isOpen()) return;
      var openPanel = document.querySelector(".panel-menu.mmitemopen");
      if (!openPanel) return;
      var focusable = openPanel.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },
    true
  );
})();
